import { render, staticRenderFns } from "./materiel-remind.vue?vue&type=template&id=0b9041b2"
import script from "./materiel-remind.vue?vue&type=script&lang=js"
export * from "./materiel-remind.vue?vue&type=script&lang=js"
import style0 from "./materiel-remind.vue?vue&type=style&index=0&id=0b9041b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports